
<template>
    <b-card no-body>
        
            <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" scrollable no-close-on-esc no-close-on-backdrop>
                <administrative-level-group-create-or-update v-model="administrativeLevelGroup" :errors="errors"></administrative-level-group-create-or-update>
                <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
            </b-modal>
        
            <v-table    ref="table"
                        :buttons="buttons"
                        :fields="fields"
                        name="administrativeLevelGroup"
                        pagination="server"
                        search
                        :items-provider="provider"
                        :add-callback="createNew"></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import AdministrativeLevelGroupCreateOrUpdate from './components/AdministrativeLevelGroupCreateOrUpdate.vue'
import HRParametersApi from '@/api/human-resources-parameters'
export default {
    components:{
        BCard,
        AdministrativeLevelGroupCreateOrUpdate
    },
    data(){
        return{
            fields:[
                {name:"Kod",key:"Code", thClass:"w-30",sortable:true},
                {name:"Ad",key:"Name", thClass:"w-50",sortable:true},
                {name:"Öncelik",key:"Priority", thClass:"w-20",sortable:true}
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            editing:false,
            errors:{},
            loading:false,
            administrativeLevelGroup:{
                Id:null,
                Name:null,
                Code:null,
                Priority:null
            }
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.administrativeLevelGroup.Id = null
            this.administrativeLevelGroup.Name = null
            this.administrativeLevelGroup.Code = null
            this.administrativeLevelGroup.Priority = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        provider(data){
            return HRParametersApi.AdministrativeLevelGroup.Table(data)
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.administrativeLevelGroup.Id = item.Id
            this.administrativeLevelGroup.Name = item.Name
            this.administrativeLevelGroup.Code = item.Code
            this.administrativeLevelGroup.Priority = item.Priority
            this.$showModal('create-or-update')
        },
        createOrUpdate(){
            this.loading = true
            HRParametersApi.AdministrativeLevelGroup.CreateOrUpdate(this.editing,this.administrativeLevelGroup).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$hideModal('create-or-update')
                    this.$refs.table.refresh()
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} düzey grubunu silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    HRParametersApi.AdministrativeLevelGroup.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
    }
}
</script>
